var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-2h30v30H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#80959D",
    d: "M1 1.273V25l3.33-3.716 3.397 3.397 3.484-3.763 3.556 3.763 3.556-3.763 3.547 3.763V1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M4.424 7.704H7.04l1.766 6.261h6.385l1.754-4.65h-9.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M9.91 18.343a1.043 1.043 0 1 0 0-2.087 1.043 1.043 0 0 0 0 2.087zM14.407 18.343a1.043 1.043 0 1 0 0-2.087 1.043 1.043 0 0 0 0 2.087z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPurchase);
export default __webpack_public_path__ + "static/media/last-purchase.b9e64a84134c8ed8adb3473ff0398afb.svg";
export { ForwardRef as ReactComponent };